import {
  LOADING_ARRAY,
  LIST_COMMUNITIES_REQUEST,
  LIST_COMMUNITIES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// current -> [communityId, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_COMMUNITIES_REQUEST:
      return {
        ...state,
        current: state.current || LOADING_ARRAY,
      }
    case LIST_COMMUNITIES_RESPONSE:
      return {
        ...state,
        current: (action.communities || []).map((c) => (c.id)),
      }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
